import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  getNotificationMessage,
  setGoToMinZoomOut,
  markersSelectors
} from 'store'
import { REJECTED } from 'utils/constants'
import {
  isAuth,
  isLiteralNumber
} from 'utils/helpers'

import { VerificationCodeModal } from '../Auth/VerificationCodeModal'
import { FiltersData } from './FiltersData'
import { Map } from './Map'
import { StyledContentContainer } from './styled'
import { UsersCount } from './UsersCount'
import { BlogModal } from './BlogModal'
import { EventMarkerLegendOverlay } from './EventMarkerLegendOverlay'
import { EventPane } from './EventPane'
import { ImageCarouselModal } from './ImageCarouselModal'

export const Content = () => {
  const dispatch = useDispatch()

  const [visibleMarkersCount, setVisibleMarkersCount] = useState([])
  const [showMarkerCount, setShowMarkerCount] = useState('flex')
  const zoom = localStorage.getItem('zoom')
  const isFiltered = localStorage.getItem('is-filtered')
  const { eventData, isImageCarouselOpen } = useSelector(markersSelectors)

  const [searchParams, setSearchParams] = useSearchParams()

  const id = searchParams.get('id')
  const eventid = searchParams.get('eventid')

  const goToMinZoomOut = () => dispatch(setGoToMinZoomOut(true))

  if (id !== null && eventid === null) {
    if (isLiteralNumber(id)) {
      sessionStorage.setItem('id', id)

      if (
        !isAuth()
        && searchParams.get('from') === 'qrcode'
      ) {
        sessionStorage.setItem('sendConnReqTo', id)
      }

      if (searchParams.get('from') === 'qrcode') {
        setSearchParams({ id })
      }
    } else {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Invalid URL parameters',
          isEditProfile: true
        })
      )
    }
  } else if (eventid !== null && id === null) {
    if (isLiteralNumber(eventid)) {
      sessionStorage.setItem('eventid', eventid)
    } else {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Invalid URL parameters',
          isEditProfile: true
        })
      )
    }
  }

  return (
    <StyledContentContainer>
      <VerificationCodeModal />
      <Map
        setVisibleMarkersCount={setVisibleMarkersCount}
        setShowMarkerCount={setShowMarkerCount}
        showMarkerCount={showMarkerCount}
      />
      <FiltersData showMarkerCount={showMarkerCount} />
      <UsersCount
        visibleMarkersCount={visibleMarkersCount}
        showMarkerCount={showMarkerCount}
        zoom={zoom}
        goToMinZoomOut={goToMinZoomOut}
      />
      {/* {isAuth() ? <EventMarkerLegendOverlay /> : null} */}
      <BlogModal />
      <EventPane />
      {eventData?.additional_images && sessionStorage.getItem('eventid') && isImageCarouselOpen === true ? <ImageCarouselModal /> : null}
    </StyledContentContainer>
  )
}
